export enum FlowNodeType {
  GROUP = 'group',
  NODE_AS_GROUP = 'node-as-group',
  NTE_DEVICE = 'nte-device',
  NTE_VARIABLE_DIAGNOSTIC = 'nte-variable-diagnostic',
  NTE_VARIABLE_CONFIG = 'nte-variable-config',
  NTE_VARIABLE_GROUPS = 'nte-variable-groups',
  NTE_VARIABLES_LIST = 'nte-variables-list',
  NTE_VARIABLE_SYSTEM = 'nte-variable-system',
  NTE_EVENT_RULES = 'nte-event-rules',
  NTE_INTERFACE = 'nte-interface'
}
